import { useEffect, useState } from "react";
import { addTenderType, getAllTenderTypes, toggleTenderTypeStatus, updateTenderType } from "../../services/AdminServices";
import TenderTypeList from "../../components/AdminComponents/PagesComponents/TenderTypes/TenderTypeList";
import AddTenderTypeModal from "../../components/AdminComponents/PagesComponents/TenderTypes/AddTenderTypeModal";
import MessageModal from "../../components/AdminComponents/Modals/MessageModal";
import ConfirmActionModal from "../../components/AdminComponents/Modals/ConfirmActionModal";

const AdminTenderTypePage = () => {
    const [openModal, setOpenModal] = useState(false);
    const [editData, setEditData] = useState(null);

    const [tenderTypes, setTenderTypes] = useState([]);
    const [loading, setLoading] = useState(false);

    const [confirmModal, setConfirmModal] = useState({
        open: false,
        tenderType: null
    });

    const [messageModal, setMessageModal] = useState({
        open: false,
        type: "success",
        title: "",
        message: ""
    });

    const showSuccess = (msg) => {
        setMessageModal({
            open: true,
            type: "success",
            title: "Success",
            message: msg,
        });
    };

    const showError = (msg) => {
        setMessageModal({
            open: true,
            type: "error",
            title: "Error",
            message: msg,
        });
    };

    const handleToggleRequest = (tenderType) => {
        setConfirmModal({ open: true, tenderType });
    };

    const handleConfirmToggle = async () => {
        try {
            await toggleTenderTypeStatus(confirmModal.tenderType.id);
            await LoadTenderTypes();
            showSuccess(confirmModal.tenderType.active ? "Tender type deactivated successfully" : "Tender type activated successfully");
        } catch (err) {
            showError(err?.response?.data?.message || "Something went wrong");
        } finally {
            setConfirmModal({ open: false, tenderType: null });
        }
    }

    const LoadTenderTypes = async () => {
        try {
            setLoading(true);
            const res = await getAllTenderTypes();
            if (res.success) {
                setTenderTypes(res.data);
            }
        } catch (err) {
            console.error(err?.response?.data?.message);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        LoadTenderTypes();
    }, [])


    const handleSave = async (formData) => {
        try {
            console.log(formData);
            let res;
            if (editData && editData.id) {
                try {
                    res = await updateTenderType(editData.id, formData);
                } catch (err) {
                    showError(err?.response?.data?.message || "Something went wrong");
                }
            } else {
                res = await addTenderType(formData);
            }

            if (res?.success) {
                await LoadTenderTypes();
                setOpenModal(false);
                setEditData(null);
                showSuccess(res.message);
            }
        } catch (err) {
            showError(err?.response?.data?.message || "Something went wrong");

        }
    };

    return (
        <div className="p-4 admin-card-box space-y-4">
            <div className="flex justify-between items-center">
                <h2 className="admin-heading text-blue">Tender Types</h2>
                <button
                    className="btnAdd"
                    onClick={() => {
                        setEditData(null);
                        setOpenModal(true);
                    }}
                >
                    + Add Tender Type
                </button>
            </div>

            <TenderTypeList
                data={tenderTypes}
                loading={loading}
                onEdit={(d) => {
                    setEditData(d);
                    setOpenModal(true);
                }}
                onToggle={handleToggleRequest}
            />

            <AddTenderTypeModal
                open={openModal}
                editData={editData}
                onClose={() => {
                    setOpenModal(false);
                    setEditData(null);
                }}
                onSave={handleSave}
            />


            <ConfirmActionModal
                open={confirmModal.open}
                title={
                    confirmModal.tenderType?.active
                        ? "Deactivate Designation"
                        : "Activate Designation"
                }
                message={
                    confirmModal.tenderType?.active
                        ? "Do you really want to deactivate this designation?"
                        : "Do you want to activate this designation again?"
                }
                confirmText={
                    confirmModal.tender?.active ? "DEACTIVATE" : "ACTIVATE"
                }
                onConfirm={handleConfirmToggle}
                onClose={() =>
                    setConfirmModal({ open: false, ward: null })
                }
            />

            <MessageModal
                open={messageModal.open}
                type={messageModal.type}
                title={messageModal.title}
                message={messageModal.message}
                onClose={() =>
                    setMessageModal({ ...messageModal, open: false })
                }
            />

        </div>
    )
}

export default AdminTenderTypePage;
